export default class UptimeRobot {

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}/UptimeRobot`;

    }

    getMonits() {

        let self = this;
        return self.axios.get(`${self.baseUrl}/monits`, self.user)
    
    }
}




// WEBPACK FOOTER //
// ./src/services/UptimeService.js